import { CustomTextLayerProps } from './CustomTextLayer.props';

const CustomTextLayer = ({ words, pageWidth, renderedWidth }: CustomTextLayerProps) => {
  const scale = renderedWidth / pageWidth;

  const processedWords = words.map((word, i) => {
    const next = words[i + 1];
    let {width} = word;
    let {text} = word;

    if (next && Math.abs(next.top - word.top) < word.height * 0.5 && next.left > word.left) {
      const gap = next.left - (word.left + word.width);
      if (gap > 0 && gap < word.height * 2) {
        width = next.left - word.left;
        text += ' ';
      }
    }
    return { ...word, width, text };
  });

  return (
    <>
      {processedWords.map((word, i) => (
        <span
          key={word.id}
          data-word-id={word.id}
          data-index={i}
          style={{
            position: 'absolute',
            left: `${word.left * scale}px`,
            top: `${word.top * scale}px`,
            width: `${word.width * scale}px`,
            height: `${word.height * scale}px`,
            fontSize: `${word.height * scale * 1.5}px`,
            color: 'transparent',
            cursor: 'text',
            userSelect: 'text',
            WebkitUserSelect: 'text',
            lineHeight: `${word.height * scale}px`,
            whiteSpace: 'pre',
          }}>
          {word.text}
        </span>
      ))}
    </>
  );
};

export default CustomTextLayer;
